import { render, staticRenderFns } from "./ReservaCartaoCancelar.vue?vue&type=template&id=c2ed5dc0&scoped=true&"
import script from "./ReservaCartaoCancelar.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoCancelar.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoCancelar.vue?vue&type=style&index=0&id=c2ed5dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ed5dc0",
  null
  
)

export default component.exports